import React, { useEffect, useState } from 'react';
import { ref, get, update } from 'firebase/database';
import { database } from '../firebaseConfig';

// Who sees the Quo option (same list the Send via Quo button uses).
export const QUO_CALL_EMAILS = ['kelly.olin@exprealty.com'];
export const canUseQuo = (user) => !!user && QUO_CALL_EMAILS.includes(String(user.email || '').toLowerCase());

// tel:+1XXXXXXXXXX opens the device's default calling app (Quo if it is the TEL default on Windows,
// Phone Link on other PCs, iPhone/FaceTime on a Mac, the dialer on phones). Quo documents click-to-call
// through the TEL protocol only (no quo:// scheme), so the Quo option uses the same tel: link.
export const telHref = (phone) => { let d = String(phone || '').replace(/\D/g, ''); if (d.length === 11 && d[0] === '1') d = d.slice(1); return d.length === 10 ? `tel:+1${d}` : ''; };

export const useCallingApp = (uid) => {
  const [app, setApp] = useState('default');
  useEffect(() => { if (uid) get(ref(database, `users/${uid}/profile/callingApp`)).then((s) => setApp(s.val() || 'default')).catch(() => {}); }, [uid]);
  return app;
};

export default function CallingAppSetting({ user }) {
  const [app, setApp] = useState('default');
  const [msg, setMsg] = useState('');
  useEffect(() => { if (user?.uid) get(ref(database, `users/${user.uid}/profile/callingApp`)).then((s) => setApp(s.val() || 'default')).catch(() => {}); }, [user?.uid]);
  const save = async (v) => { setApp(v); try { await update(ref(database, `users/${user.uid}/profile`), { callingApp: v }); setMsg('Saved.'); } catch (e) { setMsg(`Could not save: ${e.message}`); } };
  return (
    <div style={{ margin: '12px 0', padding: 12, border: '1px solid #d8c9a8', borderRadius: 8 }}>
      <strong>Calling app</strong>
      <div style={{ fontSize: 13, color: '#666', margin: '4px 0 8px' }}>The Call buttons open this app with the number filled in. You still press Call there.</div>
      <select value={app} onChange={(e) => save(e.target.value)}>
        <option value="default">Device default (Phone Link on Windows, iPhone/FaceTime on Mac, your phone's dialer)</option>
        {canUseQuo(user) && <option value="quo">Quo (set Quo as the TEL default app in Windows)</option>}
      </select> {msg && <span style={{ fontSize: 12 }}>{msg}</span>}
    </div>
  );
}
